// extracted by mini-css-extract-plugin
export default {"scrollY":"scrollY--Ls01Q"};